import {InjectionToken} from '@angular/core';

// ─────────────────────────────────────────────────────────────────────────────
// Tipi
// ─────────────────────────────────────────────────────────────────────────────

/** Funzione che trasforma i dati dell'errore in una stringa leggibile. */
export type MessageFn = (errorData: unknown) => string;

/** Mappa errore-chiave → funzione messaggio. */
export type ValidationMessageMap = Record<string, MessageFn>;

// ─────────────────────────────────────────────────────────────────────────────
// Messaggi di default (italiano)
// ─────────────────────────────────────────────────────────────────────────────

export const DEFAULT_VALIDATION_MESSAGES: ValidationMessageMap = {
  required: () => 'Campo obbligatorio',
  email: () => 'Indirizzo email non valido',
  minlength: (e: any) => `Minimo ${e.requiredLength} caratteri (inseriti: ${e.actualLength})`,
  maxlength: (e: any) => `Massimo ${e.requiredLength} caratteri`,
  min: (e: any) => `Il valore minimo consentito è ${e.min}`,
  max: (e: any) => `Il valore massimo consentito è ${e.max}`,
  pattern: () => 'Il formato inserito non è valido',
  partitaIvaAsync: () => 'Partita IVA già registrata o non verificabile',
  partitaIva: (e: any) => e?.message || 'Partita IVA non valida',
  codiceFiscale: (e: any) => e?.message || 'Codice fiscale non valido',
  telefono: (e: any) => e?.message || 'Numero di telefono non valido',
  cap: (e: any) => e?.message || 'CAP non valido',
  invalidOption: () => 'Seleziona un valore dalla lista',
  passwordStrength: () =>
    'La password deve contenere maiuscola, minuscola, numero e carattere speciale',
  passwordMismatch: () => 'Le password non coincidono',
  emailInUso: () => 'Indirizzo e-mail già in uso da un altro utente',
};

// ─────────────────────────────────────────────────────────────────────────────
// InjectionToken
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Token per iniettare messaggi di validazione custom a livello di applicazione
 * o di singolo form.
 *
 * Utilizzo nell'AppModule / AppConfig:
 * ```ts
 * providers: [
 *   {
 *     provide: VALIDATION_MESSAGES_TOKEN,
 *     useValue: {
 *       myCustomError: (e) => `Errore custom: ${e.detail}`
 *     }
 *   }
 * ]
 * ```
 *
 * I messaggi custom hanno precedenza sui messaggi di default.
 */
export const VALIDATION_MESSAGES_TOKEN =
  new InjectionToken<ValidationMessageMap>('VALIDATION_MESSAGES', {
    providedIn: 'root',
    factory: () => ({}),
  });
